import { AppLayout } from '../../themes/AppLayout';
import React from 'react';

const CreateUserPage = () => {
	return <AppLayout pageTitle='Create new User'>CreateUserPage</AppLayout>;
};

export default CreateUserPage;
